import angular from "angular";
import template from "./admin-campus-vehicles-index.html";
import AdminSchoolLocationViewVehiclesIndexController from "./admin-campus-vehicles-index.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.schools.view.locations.view.vehicles.index",
    {
      url: "/index",
      controller: AdminSchoolLocationViewVehiclesIndexController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.view.vehicles.index", [])
  .config(config)
  .controller(
    "AdminSchoolLocationViewVehiclesIndexController",
    AdminSchoolLocationViewVehiclesIndexController,
  );
